export enum COOKIE_ITEM {
  ACCESS_TOKEN = 'mira-access-token',
  REFRESH_TOKEN = 'mira-refresh-token',
  ACCESS_EXPIRES_IN = 'mira-access-expires-in',
  REFRESH_EXPIRES_IN = 'mira-refresh-expires-in',
}
